import React, { useState, useEffect } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export const CMRichTextEditor = (props: any) => {
    const { value } = props;

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
        // EditorState.createWithContent(ContentState.createFromText(value?value: ""))
    );

    //     const [editorState, setEditorState]:any = useState(() =>
    //     EditorState.createWithContent(
    //       ContentState.createFromBlockArray(
    //         convertFromHTML('<p>My initial content.</p>')
    //       )
    //     )
    //   );

    useEffect(() => {
        // const textToConvert = '<p>A paragraph</p>';
        if (value) {
            const blocksFromHTML = convertFromHTML(value);
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)))
        }

    }, [])

    const [editorContent, setEditorContent] = useState(
        '<img src="https://letipbackend.dhxdemo.com/img/letip-email-logo.png" alt="LeTip" style="max-width: 100%; border: none; font-family: Avenir, Helvetica, sans-serif; box-sizing: border-box;">sadja</img>'
    );

    // const handleChange = (res: any) => {
    //     console.log(res, "$$$$$$")

    // }

    useEffect(() => {
        setEditorContent(
            draftToHtml(convertToRaw(editorState.getCurrentContent()))
        );


    }, [editorState]);

    useEffect(() => {
        props.onChange(editorContent)
    }, [editorContent])

    return (
        <div>
            <div
                style={{
                    border: '1px solid white',
                    padding: '2px',
                    // minHeight: '100px',
                }}
            >
                <Editor
                    editorState={editorState}
                    // onEditorStateChange={handleChange}
                    onEditorStateChange={setEditorState}
                />
            </div>
        </div>
    );
}
